'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib_es6 = require('../tslib.es6-130a177d.js');
var React = require('react');
var styled = require('styled-components');
var scroll = require('../scroll-10f2cb64.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var DEBOUNCE_TIMEOUT = 50;
var Direction;
(function (Direction) {
    Direction["PREV"] = "PREV";
    Direction["NEXT"] = "NEXT";
})(Direction || (Direction = {}));
var getCurrentIndex = function (position, stepWidth) { return parseFloat((position / stepWidth).toFixed(0)); };
var DEFAULT_STEP_WIDTH = process.env.NODE_ENV === 'test' ? 100 : 0;
var useScrollableContainer = function (_a) {
    var onIndexChange = _a.onIndexChange, orientation = _a.orientation, _b = _a.debounce, debounce = _b === void 0 ? true : _b, _c = _a.defaultStepWidth, defaultStepWidth = _c === void 0 ? DEFAULT_STEP_WIDTH : _c;
    var scrollRef = React.useRef(null);
    var _d = React.useState(false), isScrolling = _d[0], setIsScrolling = _d[1];
    var _e = React.useState([]), scrollStack = _e[0], setScrollStack = _e[1];
    var getVisibleAreaWidth = React.useCallback(function () {
        if (scrollRef && scrollRef.current) {
            var stepWidth = scrollRef.current.clientWidth;
            return stepWidth > 0 ? stepWidth : defaultStepWidth;
        }
        return defaultStepWidth;
    }, [defaultStepWidth]);
    React.useEffect(function () {
        var timeout;
        var container = scrollRef.current;
        if (!container) {
            return undefined;
        }
        var listener = function () {
            setIsScrolling(true);
            if (timeout !== undefined) {
                clearTimeout(timeout);
            }
            timeout = setTimeout(function () {
                setIsScrolling(false);
                var stepWidth = getVisibleAreaWidth();
                var index = 0;
                if (container) {
                    if (orientation === 'horizontal') {
                        index = getCurrentIndex(container.scrollLeft, stepWidth);
                    }
                    else if (orientation === 'vertical') {
                        index = getCurrentIndex(container.scrollTop, stepWidth);
                    }
                }
                onIndexChange(index);
            }, DEBOUNCE_TIMEOUT);
        };
        container.addEventListener('scroll', listener);
        return function () {
            if (timeout !== undefined) {
                clearTimeout(timeout);
            }
            container.removeEventListener('scroll', listener);
        };
    }, [getVisibleAreaWidth, orientation, onIndexChange]);
    React.useEffect(function () {
        if (scrollStack.length && !isScrolling) {
            scrollStack[0]();
            scrollStack.shift();
        }
    }, [scrollStack, isScrolling]);
    var scrollToIndex = React.useCallback(function (index) {
        if (scrollRef && scrollRef.current) {
            var scrollOffset = getVisibleAreaWidth() * index;
            var container = scrollRef.current;
            if (orientation === 'horizontal') {
                container.scrollLeft = scrollOffset;
            }
            else if (orientation === 'vertical') {
                container.scrollTop = scrollOffset;
            }
            onIndexChange(index);
        }
    }, [getVisibleAreaWidth, orientation, onIndexChange]);
    var scrollInDirection = function (direction) {
        var container = scrollRef.current;
        if (container) {
            var stepWidth = getVisibleAreaWidth();
            var directionValue = direction === Direction.NEXT ? 1 : -1;
            var orientationProp = orientation === 'horizontal' ? 'scrollLeft' : 'scrollTop';
            var index = getCurrentIndex(container[orientationProp], stepWidth);
            container[orientationProp] += directionValue * stepWidth;
            var newIndex = directionValue * (index + 1);
            var availableChildren = container.childElementCount;
            if (newIndex < availableChildren && newIndex >= 0) {
                scrollToIndex(newIndex);
            }
        }
    };
    var handleScrollInDirection = function (direction) {
        if (debounce) {
            setScrollStack(tslib_es6.__spreadArrays(scrollStack, [function () { return scrollInDirection(direction); }]));
        }
        else {
            scrollInDirection(direction);
        }
    };
    return {
        scrollRef: scrollRef,
        scrollToIndex: scrollToIndex,
        scrollToPrev: function () { return handleScrollInDirection(Direction.PREV); },
        scrollToNext: function () { return handleScrollInDirection(Direction.NEXT); },
    };
};

var StyledScrollContainer = styled__default['default'].div.withConfig({ displayName: "ww-uikit_StyledScrollContainer_locmlrcx", componentId: "sc-4f6ys4" })(templateObject_3 || (templateObject_3 = tslib_es6.__makeTemplateObject(["\n    display: flex;\n    height: 100%;\n    scroll-behavior: ", ";\n\n    ", "\n"], ["\n    display: flex;\n    height: 100%;\n    scroll-behavior: ", ";\n\n    ",
    "\n"])), function (_a) {
    var scrollBehavior = _a.scrollBehavior;
    return scrollBehavior !== null && scrollBehavior !== void 0 ? scrollBehavior : 'auto';
}, function (_a) {
    var $orientation = _a.$orientation;
    if ($orientation === 'horizontal') {
        return styled.css(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n                max-width: 100vw;\n                flex-direction: row;\n                scroll-snap-type: x mandatory;\n                ", "\n            "], ["\n                max-width: 100vw;\n                flex-direction: row;\n                scroll-snap-type: x mandatory;\n                ", "\n            "])), scroll.scroll('x', true));
    }
    return styled.css(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject(["\n            ", "\n            max-height: 100vh;\n            flex-direction: column;\n            overscroll-behavior-y: contain;\n            scroll-snap-type: y mandatory;\n            overflow-y: auto;\n        "], ["\n            ", "\n            max-height: 100vh;\n            flex-direction: column;\n            overscroll-behavior-y: contain;\n            scroll-snap-type: y mandatory;\n            overflow-y: auto;\n        "])), scroll.scroll('y', true));
});
var HorizontalScrollableSnap = styled__default['default'].div.withConfig({ displayName: "ww-uikit_HorizontalScrollableSnap_locmlrcx", componentId: "sc-1qt3ep5" })(templateObject_4 || (templateObject_4 = tslib_es6.__makeTemplateObject(["\n    ", "\n    flex: 1 0 auto;\n"], ["\n    ", "\n    flex: 1 0 auto;\n"])), function (_a) {
    var scrollSnapAlign = _a.scrollSnapAlign;
    return scrollSnapAlign && "scroll-snap-align: " + scrollSnapAlign + ";";
});
var ScrollableContainer = function (_a) {
    var children = _a.children, className = _a.className, orientation = _a.orientation, scrollBehavior = _a.scrollBehavior, _b = _a.scrollOffset, scrollOffset = _b === void 0 ? 0 : _b, scrollRef = _a.scrollRef, rest = tslib_es6.__rest(_a, ["children", "className", "orientation", "scrollBehavior", "scrollOffset", "scrollRef"]);
    var scrollableContainerRef = React.useRef(null);
    var innerRef = scrollRef || scrollableContainerRef;
    React.useEffect(function () {
        var container = innerRef.current;
        if (container) {
            if (orientation === 'horizontal') {
                container.scrollLeft = scrollOffset;
            }
            else {
                container.scrollTop = scrollOffset;
            }
        }
    }, [innerRef, orientation, scrollOffset]);
    return (React.createElement(StyledScrollContainer, { "$orientation": orientation, className: className, ref: innerRef, scrollBehavior: scrollBehavior, "data-testid": rest['data-testid'] }, children));
};
var HorizontalScrollableContainer = function (props) { return React.createElement(ScrollableContainer, tslib_es6.__assign({ orientation: "horizontal" }, props)); };
ScrollableContainer.Horizontal = HorizontalScrollableContainer;
var VerticalScrollableContainer = function (props) { return React.createElement(ScrollableContainer, tslib_es6.__assign({ orientation: "vertical" }, props)); };
ScrollableContainer.Vertical = VerticalScrollableContainer;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;

exports.HorizontalScrollableContainer = HorizontalScrollableContainer;
exports.HorizontalScrollableSnap = HorizontalScrollableSnap;
exports.StyledScrollContainer = StyledScrollContainer;
exports.VerticalScrollableContainer = VerticalScrollableContainer;
exports.default = ScrollableContainer;
exports.useScrollableContainer = useScrollableContainer;
//# sourceMappingURL=index.js.map
